<!--Options-->
<div class="ItemBorder">
	<div class="MainGrid2Col">
		<label>School:</label>
		<caass-schoolselector [ShowAll]="true" [ShowAllID]="SchoolSelectShowAllID" [ShowAllText]="SchoolSelectShowAllText"> </caass-schoolselector>

		<label>App:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="RegAppTypeID" [(ngModel)]="RegAppTypeID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstRegAppType" [ngValue]="o.RegAppTypeID">{{ o.RegAppTypeDesc }}</option>
		</select>

		<label>Start Date:</label>
		<p-calendar
			showIcon="true"
			showButtonBar="true"
			[(ngModel)]="StartDate"
			name="StartDate"
			(ngModelChange)="onStartDateChange($event)"
			appendTo="body"
		></p-calendar>

		<label>End Date:</label>
		<p-calendar
			showIcon="true"
			showButtonBar="true"
			[(ngModel)]="EndDate"
			name="EndDate"
			(ngModelChange)="onEndDateChange($event)"
			appendTo="body"
		></p-calendar>

		<label>Active in CAASS:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="ActiveOptionID" [(ngModel)]="ActiveOptionID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstActiveOption" [ngValue]="o.ID">{{ o.Desc }}</option>
		</select>

		<!--Student Options-->
		<label *ngIf="ShowStudentOptions() == true">Grade Level:</label>
		<select *ngIf="ShowStudentOptions() == true" [disabled]="IsLoading() == true" class="form-control" name="GradeLevelID" [(ngModel)]="GradeLevelID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstGradeLevel" [ngValue]="o.GradeLevelID">{{ o.GradeLevelDesc }}</option>
		</select>

		<label *ngIf="ShowStudentOptions() == true">Homeroom:</label>
		<select *ngIf="ShowStudentOptions() == true" [disabled]="IsLoading() == true" class="form-control" name="HomeroomID" [(ngModel)]="HomeroomID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstHomeroom" [ngValue]="o.HomeroomID">{{ o.HomeroomDesc }}</option>
		</select>

		<label *ngIf="ShowStudentOptions() == true">Academy:</label>
		<select *ngIf="ShowStudentOptions() == true" [disabled]="IsLoading() == true" class="form-control" name="AcademyID" [(ngModel)]="AcademyID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstAcademy" [ngValue]="o.AcademyID">{{ o.AcademyDesc }}</option>
		</select>

		<label *ngIf="ShowStudentOptions() == true">Group:</label>
		<select *ngIf="ShowStudentOptions() == true" [disabled]="IsLoading() == true" class="form-control" name="GroupID" [(ngModel)]="GroupID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstGroup" [ngValue]="o.GroupID">{{ o.GroupName }}</option>
		</select>
	</div>

	<div class="Buttons">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onRefresh()">Refresh</button>
	</div>
</div>

<!--Table Options-->
<div class="ItemBorder TopMargin">
	<div class="ShowOptionDiv">
		<input name="ShowID" id="ShowID" type="checkbox" class="CHK" [(ngModel)]="ShowID" />
		<label for="ShowID">Sent for Student/Staff ID</label>

		<input name="ShowFirstName" id="ShowFirstName" type="checkbox" class="CHK" [(ngModel)]="ShowFirstName" />
		<label for="ShowFirstName">Sent for First Name</label>

		<input name="ShowLastName" id="ShowLastName" type="checkbox" class="CHK" [(ngModel)]="ShowLastName" />
		<label for="ShowLastName">Sent for Last Name</label>

		<input name="ShowSchoolName" id="ShowSchoolName" type="checkbox" class="CHK" [(ngModel)]="ShowSchoolName" />
		<label for="ShowSchoolName">School</label>

		<input name="ShowAppDesc" id="ShowAppDesc" type="checkbox" class="CHK" [(ngModel)]="ShowAppDesc" />
		<label for="ShowAppDesc">App</label>

		<input name="ShowNotificationTypeDesc" id="ShowNotificationTypeDesc" type="checkbox" class="CHK" [(ngModel)]="ShowNotificationTypeDesc" />
		<label for="ShowNotificationTypeDesc">Notification Type</label>

		<input
			name="ShowNotificationQueueStatusDesc"
			id="ShowNotificationQueueStatusDesc"
			type="checkbox"
			class="CHK"
			[(ngModel)]="ShowNotificationQueueStatusDesc"
		/>
		<label for="ShowNotificationQueueStatusDesc">Status</label>

		<input name="ShowUserID_Email" id="ShowUserID_Email" type="checkbox" class="CHK" [(ngModel)]="ShowUserID_Email" />
		<label for="ShowUserID_Email">Recipient Email</label>

		<input name="ShowUserFirstName" id="ShowUserFirstName" type="checkbox" class="CHK" [(ngModel)]="ShowUserFirstName" />
		<label for="ShowUserFirstName">Recipient First Name</label>

		<input name="ShowUserLastName" id="ShowUserLastName" type="checkbox" class="CHK" [(ngModel)]="ShowUserLastName" />
		<label for="ShowUserLastName">Recipient Last Name</label>

		<input name="ShowLogDT" id="ShowLogDT" type="checkbox" class="CHK" [(ngModel)]="ShowLogDT" />
		<label for="ShowLogDT">Date/Time</label>

		<input name="ShowContentTitle" id="ShowContentTitle" type="checkbox" class="CHK" [(ngModel)]="ShowContentTitle" />
		<label for="ShowContentTitle">Title</label>

		<input name="ShowContentText" id="ShowContentText" type="checkbox" class="CHK" [(ngModel)]="ShowContentText" />
		<label for="ShowContentText">Message</label>
	</div>

	<div class="Buttons">
		<button class="btn btn-primary" (click)="onResetShowOptions()">Reset Options</button>
		<button style="margin-left: 5px" class="btn btn-success" (click)="onShowAll()">Show All</button>
		<button style="margin-left: 5px" class="btn btn-danger" (click)="onClearShowOptions()">Clear Options</button>
		<button style="margin-left: 5px" class="btn btn-success" (click)="onExport()">Export .CSV</button>
	</div>
</div>

<!--Table-->
<div class="TopMargin">
	<p-table
		#mydt
		[value]="lstNotifications"
		[loading]="LoadingNotifications"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedNotification"
		dataKey="TableID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--ID-->
				<th *ngIf="ShowID == true">
					<p-columnFilter type="text" field="ID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--FirstName-->
				<th *ngIf="ShowFirstName == true">
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LastName-->
				<th *ngIf="ShowLastName == true">
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolName-->
				<th *ngIf="ShowSchoolName == true">
					<p-columnFilter field="SchoolName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSchoolName
								[ngModel]="value"
								[options]="lstSchoolName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--AppDesc-->
				<th *ngIf="ShowAppDesc == true">
					<p-columnFilter field="AppDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterAppDesc
								[ngModel]="value"
								[options]="lstAppDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--NotificationTypeDesc-->
				<th *ngIf="ShowNotificationTypeDesc == true">
					<p-columnFilter field="NotificationTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterNotificationTypeDesc
								[ngModel]="value"
								[options]="lstNotificationTypeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--NotificationQueueStatusDesc-->
				<th *ngIf="ShowNotificationQueueStatusDesc == true">
					<p-columnFilter field="NotificationQueueStatusDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterNotificationQueueStatusDesc
								[ngModel]="value"
								[options]="lstNotificationQueueStatusDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--UserID_Email-->
				<th *ngIf="ShowUserID_Email == true">
					<p-columnFilter type="text" field="UserID_Email" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--UserFirstName-->
				<th *ngIf="ShowUserFirstName == true">
					<p-columnFilter type="text" field="UserFirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--UserLastName-->
				<th *ngIf="ShowUserLastName == true">
					<p-columnFilter type="text" field="UserLastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LogDT-->
				<th *ngIf="ShowLogDT == true">
					<!-- <p-columnFilter type="text" field="LogDT" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--ContentTitle-->
				<th *ngIf="ShowContentTitle == true">
					<p-columnFilter type="text" field="ContentTitle" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ContentText-->
				<th *ngIf="ShowContentText == true">
					<p-columnFilter type="text" field="ContentText" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th *ngIf="ShowID == true" pSortableColumn="ID">Sent for Student/Staff ID<p-sortIcon field="ID"></p-sortIcon></th>
				<th *ngIf="ShowFirstName == true" pSortableColumn="FirstName">Sent for First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th *ngIf="ShowLastName == true" pSortableColumn="LastName">Sent for Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th *ngIf="ShowSchoolName == true" pSortableColumn="SchoolName">School<p-sortIcon field="SchoolName"></p-sortIcon></th>
				<th *ngIf="ShowAppDesc == true" pSortableColumn="AppDesc">App<p-sortIcon field="AppDesc"></p-sortIcon></th>
				<th *ngIf="ShowNotificationTypeDesc == true" pSortableColumn="NotificationTypeDesc">
					Notification Type<p-sortIcon field="NotificationTypeDesc"></p-sortIcon>
				</th>
				<th *ngIf="ShowNotificationQueueStatusDesc == true" pSortableColumn="NotificationQueueStatusDesc">
					Status<p-sortIcon field="NotificationQueueStatusDesc"></p-sortIcon>
				</th>
				<th *ngIf="ShowUserID_Email == true" pSortableColumn="UserID_Email">Recipient Email<p-sortIcon field="UserID_Email"></p-sortIcon></th>
				<th *ngIf="ShowUserFirstName == true" pSortableColumn="UserFirstName">Recipient First Name<p-sortIcon field="UserFirstName"></p-sortIcon></th>
				<th *ngIf="ShowUserLastName == true" pSortableColumn="UserLastName">Recipient Last Name<p-sortIcon field="UserLastName"></p-sortIcon></th>
				<th *ngIf="ShowLogDT == true" pSortableColumn="LogDT">Date/Time<p-sortIcon field="LogDT"></p-sortIcon></th>
				<th *ngIf="ShowContentTitle == true" pSortableColumn="ContentTitle">Title<p-sortIcon field="ContentTitle"></p-sortIcon></th>
				<th *ngIf="ShowContentText == true" pSortableColumn="ContentText">Message<p-sortIcon field="ContentText"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Notification>
			<tr [pSelectableRow]="Notification">
				<td *ngIf="ShowID == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Notification.ID }}
				</td>
				<td *ngIf="ShowFirstName == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Notification.FirstName }}
				</td>
				<td *ngIf="ShowLastName == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Notification.LastName }}
				</td>
				<td *ngIf="ShowSchoolName == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Notification.SchoolName }}
				</td>
				<td *ngIf="ShowAppDesc == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Notification.AppDesc }}
				</td>
				<td *ngIf="ShowNotificationTypeDesc == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Notification.NotificationTypeDesc }}
				</td>
				<td *ngIf="ShowNotificationQueueStatusDesc == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Notification.NotificationQueueStatusDesc }}
				</td>
				<td *ngIf="ShowUserID_Email == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Notification.UserID_Email }}
				</td>
				<td *ngIf="ShowUserFirstName == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Notification.UserFirstName }}
				</td>
				<td *ngIf="ShowUserLastName == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Notification.UserLastName }}
				</td>
				<td *ngIf="ShowLogDT == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Notification.LogDTDesc }}
				</td>
				<td *ngIf="ShowContentTitle == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Notification.ContentTitle }}
				</td>
				<td *ngIf="ShowContentText == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Notification.ContentText }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
